import { Button } from "../../../../common/components/Button/Button";
import "./MBIMetricLegend.scss";
import MBIMetricLegendAwardTranslation from "./MBIMetricLegendAwardTranslation";

type Props = {
  bonusAwd: number;
  showMonthlyTitle?: boolean;
  truncateText?: boolean;
  selectedAwardCode?: number;
  onClick?: Function;
  theme: "button" | "color-dot-title" | "color-bg-title" | "color-dot" | "color-dot-without-title";
  fontSize?: "small" | "normal" | "medium" | "big" | "huge" | "large";
  fontWeight?: "thin" | "regular" | "medium" | "bold";
  title?: string;
};

const MBIMetricLegend = (props: Props) => {
  const {
    bonusAwd,
    theme,
    truncateText = true,
    onClick,
    fontSize,
    fontWeight,
    showMonthlyTitle,
    selectedAwardCode,
    title = "",
  } = props;

  const evaluateProps = () => {
    return `${fontSize ? `mbi--${fontSize}` : ""} ${fontWeight ? `mbi--${fontWeight}` : ""} ${
      truncateText ? `truncate` : ""
    }`;
  };

  const _onClick = () => {
    onClick && onClick(bonusAwd);
  };

  if (theme === "button") {
    return (
      <div className={truncateText ? `mbi_btn_wrapper` : ""}>
        <Button
          onClick={_onClick}
          className={`mbi_round_button_${bonusAwd}${
            bonusAwd === selectedAwardCode ? ` mbi_round_button_${bonusAwd}_selected` : ``
          }`}
        >
          <span className="button_dot"></span>
          <span className={`${evaluateProps()}`}>
            <MBIMetricLegendAwardTranslation bonusAwd={bonusAwd} showMonthlyTitle={showMonthlyTitle} />
          </span>
        </Button>
      </div>
    );
  }

  if (theme === "color-bg-title") {
    return (
      <div className={`mbi_bg_wrapper_${bonusAwd}`}>
        <div className={`${evaluateProps()}`}>
          <MBIMetricLegendAwardTranslation bonusAwd={bonusAwd} showMonthlyTitle={showMonthlyTitle} />
        </div>
      </div>
    );
  }

  if (theme === "color-dot-title") {
    return (
      <div className={`mbi_dot_title_${bonusAwd}`}>
        <div className="title_dot"></div>
        <div className={`${evaluateProps()}`}>
          {title === "" ? (
            <MBIMetricLegendAwardTranslation bonusAwd={bonusAwd} showMonthlyTitle={showMonthlyTitle} />
          ) : (
            title
          )}
        </div>
      </div>
    );
  }

  if (theme === "color-dot") {
    return (
      <div className={`mbi_dot_${bonusAwd}`}>
        <svg viewBox="0 0 20 20">
          <circle cx="10" cy="10" r="10" fill="orange" />
          <circle cx="10" cy="10" r="7" fill="tomato" />
          <circle cx="10" cy="10" r="4" fill="teal" />
        </svg>
      </div>
    );
  }

  if (theme === "color-dot-without-title") {
    return (
      <div className={`mbi_dot_without_title_${bonusAwd}`}>
        <div className="title_dot"></div>
      </div>
    );
  }
  return <></>;
};

export default MBIMetricLegend;
